import SEOMetadata from "../../components/SEOMetadata";
import { seoConfig } from "../../config/seoConfig";
import EfiModel from "../../components/allModels/efiModel";
import ModelSlider from "../../components/allModels/modelSlider";
import Journey from "../../components/home/journey/journey";
import DefendBanner from "../../components/industries/defendBanner";
import DefendSlogan from "../../components/industries/defendSlogan";
import DirectSales from "../../components/industries/directSales";

const Defend = () => {
  const modelInfo = {
    title: (
      <div className="flex font-[Rockwell] 2xl:text-[40px] xl:text-[35px] lg:text-[30px] md:text-[25px] sm:text-[20px] text-[17px] font-extrabold ">
        <span className="underline  lg:decoration-[5px] sm:decoration-[4px] decoration-[2px] lg:underline-offset-[24px] md:underline-offset-[18px] sm:underline-offset-[15px] underline-offset-[8px] decoration-[#7ABF5B]">
          TUATAR
          <span className="underline  lg:decoration-[5px] sm:decoration-[4px] decoration-[2px] lg:underline-offset-[24px] md:underline-offset-[18px] sm:underline-offset-[15px] underline-offset-[8px] !decoration-[#fff]">
            A UTILITY VEHICLES
          </span>
        </span>
      </div>
    ),
    dec: `The Tuatara is a tough, versatile utility vehicle designed for demanding tasks and off-road adventures. Built with all-steel construction and an advanced Electrophoresis Anti-Rust treatment, the Tuatara is designed to withstand the harshest environments. Its 2,200 lbs pull capacity, 2,200 lbs load capacity, and 1,200 lbs hydraulic lift cargo bed make it ideal for defense and agency uses. Additionally, its selectable 2WD/4WD drivetrain and heavy-duty suspension system ensure superior adaptability in rough terrain.`,
  };
  const seoData = seoConfig.us.defend;

  return (
    <div className="bg-[#fff]">
      <SEOMetadata
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
      />
      <DefendBanner />
      <div className="bg-[#5B792E]">
        <div className="custom-container">
          <div className="md:pt-[39px] pt-[19px] md:pb-[69px] pb-[29px] flex flex-wrap	justify-between">
            <div className="flex font-[Rockwell] 2xl:text-[36px] xl:text-[30px] lg:text-[25px] sm:text-[23px] text-[16px] font-extrabold lg:border-b-[8px] sm:border-b-[4px] border-b-[2px] border-[#7ABF5B]">
              MILITARY
            </div>
            <div className="flex font-[Rockwell] 2xl:text-[36px] xl:text-[30px] lg:text-[25px] sm:text-[23px] text-[16px] font-extrabold ">
              AGENCY
            </div>
            <div className="flex font-[Rockwell] 2xl:text-[36px] xl:text-[30px] lg:text-[25px] sm:text-[23px] text-[16px] font-extrabold ">
              CONTRACT
            </div>
          </div>
        </div>
      </div>
      <div>
        <EfiModel modelInfo={modelInfo} />
      </div>

      <div className="custom-container">
        <div className="font-[Rockwell] 2xl:text-[35px] xl:text-[30px] lg:text-[25px] md:text-[20px] text-[17px] font-extrabold text-[#000] text-center pt-[56px] pb-[56px]">
          MODEL LINEUP
        </div>
        <ModelSlider />
      </div>

      <div className="bg-[#F2F2F2] mt-[100px]">
        <div className="custom-container md:px-[80px] px-[0px]">
          <DefendSlogan />
        </div>
      </div>

      <div className="bg-[#5B792E]" style={{ boxShadow: "0px 4px 4px 0px #00000040" }}>
        <DirectSales />
      </div>

      <div className="bg-[#fff]">
        <div className="custom-container md:pt-[80px] sm:pt-[60px] pt-[30px] pb-[150px] md:px-[40px] px-[0px]">
          <Journey title={" FIND THE TUATARA FOR YOUR MISSION"} />
        </div>
      </div>
    </div>
  );
};
export default Defend;
